export const DEFAULT_VALUES = {
    Guid: "00000000-0000-0000-0000-000000000000",
    APP_VERSION: "0.0.0",
    DEFAULT_DATES: ['1900-01-01', '0001-01-01', '2001-01-01']
}